module.exports = __webpack_public_path__ + "static/img/fxgj.5ccec849.jpg";